import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SaveIcon from '@mui/icons-material/Save';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import UndoIcon from '@mui/icons-material/Undo';
import { Card, CardActions, CardContent, ClickAwayListener, Collapse, Grid, IconButton, Stack, TextField } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { emailService } from '../services/EmailService';
import ErrorCard from './ErrorCard';
import LoadingCard from './LoadingCard';

export default function ContactEmailItem({ emailId, personId, resetParent }) {

  const [email, setEmail] = useState(null);
  const [updatedEmail, setUpdatedEmail] = useState(null);
  const [error, setError] = useState(null);
  const [mode, setMode] = useState("loading");
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (emailId != null) {
      emailService.getById(emailId)
        .then(
          (result) => {
            setEmail(result);
            setUpdatedEmail(result);
            console.log(result);
            if (mode === "loading") {
              setMode("view");
            }
          },
          (error) => {
            console.log(error);
            setError(error);
            setMode("error");
          }
        );
    } else if (mode === "loading") {
      setMode("view");
      setUpdatedEmail(
        {
          email: '',
          description: '',
          primary: false
        }
      )
    }
  }, [emailId, mode]);

  const togglePreferred = () => {

    emailService.update(email.id, { ...email , primary: true })
    .then(
      (result) => {
        console.log(result);
      },
      (error) => {
        console.log(error);
      }
    );
    resetParent();
  }

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUpdatedEmail({ ...updatedEmail, [name]: value });
  }

  const handleUpdateSubmit = (event) => {
    event.preventDefault();
    emailService
      .update(email.id, updatedEmail)
      .then(
        (result) => {
          setEmail(result);
          setUpdatedEmail(result);
          setMode("view");
        },
        (error) => {
          console.log(error.message);
          setError(error.message);
          setMode("error");
        }
      );
  }

  const handleCreateSubmit = (event) => {
    event.preventDefault();
    emailService
      .create({ ...updatedEmail, person_id: personId })
      .then(
        (result) => {
          setEmail(result);
          setUpdatedEmail(result);
          setMode("view");
          resetParent();
        },
        (error) => {
          console.log(error.message);
          setError(error.message);
          setMode("error");
        }
      );
  }

  const handleDeleteSubmit = (event) => {
    event.preventDefault();
    emailService
      .delete(updatedEmail.id)
      .then(
        (result) => {
          setEmail(result);
          setUpdatedEmail(result);
          setMode("view");
          resetParent();
        },
        (error) => {
          console.log(error.message);
          setError(error.message);
          setMode("error");
        }
      );
  }

  const resetCard = () => {
    setEmail(null);
    setUpdatedEmail(null);
    setError(null);
    setMode("loading");
    setExpanded(false);
  }

  // RENDER
  if (mode === "loading") {
    return (
      <LoadingCard/>
    );
  } else if (mode === "error") {
    return (
      <ErrorCard errorMessage={error} resetCard={resetCard} />
    );
  } else if (mode === 'create') {
    return (
      <ClickAwayListener onClickAway={ (e) => { e.stopPropagation(); setExpanded(false); setMode('view') }}>
        <Card raised={true}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="email" name="email" label="Correu electrònic"
                  value={ updatedEmail.email }
                  onChange={handleInputChange}
                  fullWidth variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="description" name="description" label="Descripció"
                  value={ updatedEmail.description }
                  onChange={handleInputChange}
                  fullWidth variant="outlined"
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions sx={{ justifyContent: "flex-end" }}>
            <IconButton color="primary" aria-label="no-modificar" onClick={resetCard}>
              <UndoIcon />
            </IconButton>
            <IconButton color="primary" aria-label="crear" onClick={handleCreateSubmit}>
              <SaveIcon />
            </IconButton>
          </CardActions>
        </Card>
      </ClickAwayListener>
    );
  } else if (mode === "edit") {
    return (
      <ClickAwayListener onClickAway={ (e) => { e.stopPropagation(); setExpanded(false); setMode('view') }}>
        <Card raised={expanded}>
          <CardContent>
            <Grid container mt={1} spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="email" name="email" label="Correu electrònic"
                  value={ updatedEmail.email }
                  onChange={handleInputChange}
                  fullWidth variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="description" name="description" label="Descripció"
                  value={ updatedEmail.description }
                  onChange={handleInputChange}
                  fullWidth variant="outlined"
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions sx={{ justifyContent: "flex-end" }}>
            <IconButton color="primary" aria-label="no-modificar" onClick={resetCard}>
              <UndoIcon />
            </IconButton>
            <IconButton color="primary" aria-label="modificar" onClick={handleUpdateSubmit}>
              <SaveIcon />
            </IconButton>
          </CardActions>
        </Card>
      </ClickAwayListener>
    );
  } else {
    if (email === null) {
      // VISUALITZACIO BUIT
      return (
        <Card>
          <CardActions sx={{ justifyContent: "flex-end" }}>
            <IconButton color="primary" aria-label="afegir" onClick={() => setMode("create")}>
              <AddCircleOutlineIcon />
            </IconButton>
          </CardActions>
        </Card>
      )  
    } else {
      // VISUALITZACIO AMB DADES
      return (
        <ClickAwayListener onClickAway={ (e) => { e.stopPropagation(); setExpanded(false); }}>
          <Card raised={expanded}>
            <CardContent onClick={handleExpandClick}>
              <Typography noWrap variant="body1" color="text.primary">{ email.email }</Typography>
            </CardContent>
            <Collapse in={expanded} unmountOnExit>
              { email.description !== null && email.description.length > 0 && 
                <CardContent>
                  <Typography noWrap variant="body2" color="text.secundary">{ email.description }</Typography>
                </CardContent>
              }
            </Collapse>
            { expanded && (
              <CardActions sx={{ justifyContent: "space-between" }}>
                <Stack direction="row">
                  <IconButton color="primary" aria-label="modificar" onClick={ togglePreferred }>
                    { email.primary? <StarIcon /> : <StarBorderIcon /> }
                  </IconButton>
                </Stack>
                <Stack direction="row">
                  { expanded && ( 
                    <IconButton color="primary" aria-label="modificar" onClick={ () => setMode("edit") }>
                        <EditIcon />
                    </IconButton>
                  )}
                  { expanded && !email.primary && (
                    <IconButton color="primary" aria-label="modificar" onClick={handleDeleteSubmit}>
                      <DeleteIcon />
                    </IconButton>
                  )}
                  <IconButton color="primary" aria-expanded={expanded} aria-label="show more" onClick={handleExpandClick}>
                    { expanded? <ExpandLessIcon /> : <ExpandMoreIcon /> }
                  </IconButton>
                </Stack>
              </CardActions>
            )}
          </Card>
        </ClickAwayListener>
      );
    }
  }
};
